import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Chip, Typography } from '@mui/material';
import { CohortWithDetails } from 'src/types/cohort.types';
import { FaGraduationCap } from 'react-icons/fa';

interface TeacherCohortSelectorProps {
  cohorts: CohortWithDetails[];
  selectedCohortId: string; // 'ALL' or specific cohort ID
  onSelectCohort: (cohortId: string) => void;
}

export const TeacherCohortSelector: React.FC<TeacherCohortSelectorProps> = ({
  cohorts,
  selectedCohortId,
  onSelectCohort,
}) => {
  if (!cohorts || cohorts.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        bg: '#FFFFFF',
        borderRadius: 2,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
        border: '1px solid #E2E8F0',
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: '50%',
          backgroundColor: '#FEF3C7',
          color: '#D97706',
        }}
      >
        <FaGraduationCap size={18} />
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block">
          Active Cohort Section
        </Typography>
        <Typography variant="body2" fontWeight={700} color="#1A202C">
          {selectedCohortId === 'ALL'
            ? `All My Cohorts (${cohorts.length})`
            : cohorts.find((c) => c.id === selectedCohortId)?.name || 'Selected Cohort'}
        </Typography>
      </Box>

      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="teacher-cohort-select-label">Filter Cohort</InputLabel>
        <Select
          labelId="teacher-cohort-select-label"
          value={selectedCohortId}
          label="Filter Cohort"
          onChange={(e) => onSelectCohort(e.target.value)}
        >
          <MenuItem value="ALL">
            <em>All Assigned Cohorts ({cohorts.length})</em>
          </MenuItem>
          {cohorts.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                <span>{c.className ? `${c.className} - ` : ''}{c.name}</span>
                <Chip
                  label={`${c.students?.length || 0} scholars`}
                  size="small"
                  sx={{ ml: 1, height: 20, fontSize: '0.6875rem', backgroundColor: '#EDF2F7' }}
                />
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
